import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { getDisplayMode } from '../common/libs.js';
gsap.registerPlugin(ScrollTrigger);

const setCourseTab = () => {
  const menuFloat = document.querySelector('.js-menu-float');
  const menuFloatTab = document.querySelector('.js-menu-float-tab')
  const menuFloatList = document.querySelector('.js-menu-float-list')

  if (menuFloat && menuFloatTab) {

    if (getDisplayMode() == 1) {
      menuFloat.addEventListener('mouseover', () => {
        menuFloat.classList.add('is-open');
      });

      menuFloat.addEventListener('mouseleave', () => {
        menuFloat.classList.remove('is-open');
      });
    } else {
      menuFloatTab.addEventListener('click', (e) => {
        e.preventDefault();
        menuFloat.classList.toggle('is-open');
      });

      document.addEventListener('click', (e) => {
        if (!menuFloat.contains(e.target)) {
          menuFloat.classList.remove('is-open');
        }
      });

    }

    ScrollTrigger.create({
      trigger: '.section-menu',
      markers: false,
      start: "top top",
      onEnter: () => {
        menuFloat.classList.toggle('is-active')
      },
      onLeaveBack: () => {
        menuFloat.classList.remove('is-active')
      },
      once: false,
    });

    ScrollTrigger.create({
      trigger: '.section-movie',
      markers: false,
      start: "top top",
      onEnter: () => {
        menuFloat.classList.remove('is-active')
      },
      onLeaveBack: () => {
        menuFloat.classList.toggle('is-active')
      },
      once: false,
    });
  }

};

export default setCourseTab;
